/*global _99aq:true */

import relativeTime from '@99designs/common/apps/global-nav/flight-js/ui/relative-time';
import Analytics from 'flight/data/analytics';
import VisitSourceTracker from 'flight/data/visit-source-tracker';
import blankshield from 'blankshield/blankshield';
import mediaQueryLabel from '@99designs/common/jquery-plugins/media-query-label/index';
import OnlineStatus from 'flight/data/online-status';
import AvatarOnlineIndicator from 'flight/ui/online-indicator';
import StatusOnlineIndicator from 'flight/ui/online-indicator';
import Presence from 'flight/ui/presence';
import UserTimezone from 'flight/ui/user-local-time';

export default function baseUi() {
    'use strict';

    window._99aq = window._99aq || [];

    $(document).mediaQueryLabel();

    // prevent tabnabbing via window.opener
    blankshield(document.querySelectorAll('a[target="_blank"]'));
    blankshield(document.querySelectorAll('a[rel="external"]'));

    relativeTime.attachTo('html', {
        timeSelector: 'time[datetime][data-relative-time]',
        absoluteTimeSelector: 'time[datetime][data-absolute-time]',
        cacheProcessedTimes: false,
        locale: document.documentElement.lang,
    });

    // Fire uiNeedsTimeUpdate to update relative times, 3 times a minute
    setInterval(function() {
        $(document).trigger('uiNeedsTimeUpdate');
    }, 20000);

    Analytics.attachTo(document, {
        _99aq: window._99aq,
    });

    VisitSourceTracker.attachTo(document);

    // FIXME asimov-detached-dropdown doesn't support using a link as the trigger. This is a bug. Resolve after reskin2016
    $('[data-detached-dropdown-trigger]').on('click', function(e) {
        e.preventDefault();
    });

    Presence.attachTo('html', { presenceImage: $('html').data('presence-url') });
    OnlineStatus.attachTo('html', { authToken: $('html').data('online-status-token') });
    AvatarOnlineIndicator.attachTo('html', { indicatorSelector: 'data-avatar' });
    StatusOnlineIndicator.attachTo('body', { indicatorSelector: 'data-online-status' });
    UserTimezone.attachTo('time[data-designers-time]', {
        EntryDesignerTimezone: 'data-designers-time',
    });
}



// WEBPACK FOOTER //
// ./src/js/lib/base-ui.js